import { THEME_TYPE_LITE } from 'constants/ThemeSetting';

export const getTheme = (state) => state.getIn(['ui', 'app', 'theme'], THEME_TYPE_LITE);
